/**
 * RecentlyAddedSlider.js — near-4-up swipeable slider, no arrows or dots
 */
import Swiper from 'swiper';

export default class RecentlyAddedSlider {
  constructor(selector = '.recently-added-slider') {
    this.el = document.querySelector(selector);
    if (!this.el) return;

    this.swiper = new Swiper(this.el, {
      slidesPerView: 3.85,
      spaceBetween: 20,
    });
  }
}

